var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTimeshiftEnabled)?_c('div',{directives:[{name:"accessibility-focus",rawName:"v-accessibility-focus",value:(_vm.click),expression:"click"}],staticClass:"c-player__live",class:{ 'is-live': _vm.isLive },attrs:{"aria-label":_vm.$t('accessibility.player.liveButton')}},[_c('span',[_vm._v("LIVE")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }